export function getMissionFlow(missionType: string): string | null {
  const missionFlowMap: Record<string, string> = {
    'prevention maladie cardio-vasculaire': 'mcvFlow',
    'prevention stress': 'stressFlow',
    'cancer du sein': 'breastCancerFlow',
    'prevention sante de la femme': 'healthWomenFlow',
    'prevention cancer de la peau': 'melanomaFlow',
    'prevention sante de l homme': 'healthMenFlow',
    prevention: 'preventionFlow',
    'vaccination antigrippale': 'fluFlow',
    'vaccination anti-covid19': 'covidFlow',
    'vaccination antigrippale et anti-covid19': 'vaccinationAndCovidFlow',
    'programme d’apprentissage patient': 'novartisFlow',
    'recherche clinique à domicile': 'laboFlow',
    'prevention tms': 'tmsFlow',
    'prevention endometriose': 'endometriosisFlow',
  };

  return missionFlowMap[missionType] ?? null;
}

export function generateAlertText(data: Record<string, any>): string {
  let text = '';

  if (data.ldl >= 130) {
    text += `Cholestérol LDL: <b>${data.ldl}</b> ≥ 130 mg/dL <br/>`;
  }
  if (data.hdl < 40) {
    text += `Cholestérol HDL: <b>${data.hdl}</b> < 40 mg/dL <br/>`;
  }
  if (data.triglycerides > 150) {
    text += `Triglycérides: <b>${data.triglycerides}</b> > 150 mg/dL <br/>`;
  }
  if (data.total_cholesterol >= 250) {
    text += `Cholestérol total: <b>${data.total_cholesterol}</b> ≥ 250 mg/dL <br/>`;
  }
  if (data.glycated_hemoglobin > 6.5) {
    text += `Hémoglobine glyquée: <b>${data.glycated_hemoglobin}</b> > 6,5% <br/>`;
  }
  if (data.systolic_blood_pressure > 140) {
    text += `Pression artérielle systolique (PAS): <b>${data.systolic_blood_pressure}</b> > 140 mm HG <br/>`;
  }

  return text;
}

export function generateBloodText(data: Record<string, any>): string {
  let text = '';

  if (data.glycated_hemoglobin > 6.5) {
    text += `Hémoglobine glyquée: <b>${data.glycated_hemoglobin}</b> > 6,5% <br/>`;
  }

  return text;
}

export function generateSpecialistsAlertText(data: Record<string, any>): string {
  let text = '';

  const glycated = Number(data.glycated_hemoglobin);
  if (!isNaN(glycated) && glycated > 6.5) {
    text += `Hémoglobine glyquée: <b>${glycated}</b> > 6,5% <br/>`;
  }
  if (data.drugs_treatment) {
    text += `Traitement pour l'hypolipidémie <br/>`;
  }

  return text;
}

export function calculateBmi(height: number, weight: number): number {
  if (!height || !weight) return 0;

  const heightInMeters = height / 100;
  return Number((weight / heightInMeters ** 2).toFixed(2));
}
